import StaffPerformanceCSVPreviewBaseColumnsStrategy from './StaffPerformanceCSVPreviewBaseColumnsStrategy'
import StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy from './StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy'

export default function StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy() {}

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype = Object.create(StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype)

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.init = function(includeOtherUsersColumn, groupMessageProvider) {
    StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.init.call(this, includeOtherUsersColumn, groupMessageProvider)
    return this
}

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.addMainHeaderRowCells = function(mainHeaderRow) {
    StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addMainHeaderRowCells.call(this, mainHeaderRow)

    let colTitle = this.message("report.common.user")

    this.addCell(mainHeaderRow, colTitle)
    this.addCell(mainHeaderRow, colTitle)

    if (this.includeOtherUsersColumn) this.addCell(mainHeaderRow, this.message("report.common.others"))
}

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function(colGroupingRow) {
    StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addColumnGropingHeaderRowCells.call(this, colGroupingRow)
    this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()))
    this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()))
    if (this.includeOtherUsersColumn) this.addCell(colGroupingRow, "") // above Others
}

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.getNumOfDataColumns = function() {
    return this.includeOtherUsersColumn ? 4 : 3
}






// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.js